import { motion } from "framer-motion";
import { Newspaper, ArrowUpRight, Quote } from "lucide-react";

const ARTICLES = [
  {
    media: "Noxway · TripAdvisor des clubs",
    date: "Interview · 2025",
    title:
      "DJ As, d'enfant harcelé à DJ renommé",
    quote:
      "Aujourd'hui, on est presque 350 000 abonnés, et on dépasse les 200 millions de vues en cinq ans.",
    url: "https://noxway.fr/blog/dj-club-interview-DJ%20As",
    accent: "from-[#FF2D9C]/40 via-[#A855F7]/15 to-transparent",
    badge: "Interview longue",
  },
  {
    media: "Ouest-France",
    date: "28 septembre 2025",
    title:
      "À Alençon, le créateur du tube Last Night, DJ Robbie, tourne un clip avec Coulisse DJ",
    quote:
      "Le morceau approche déjà les 80 000 écoutes et vient d'entrer à la 30ᵉ place du classement des clubs nationaux.",
    url: "https://www.ouest-france.fr/culture/musiques/a-alencon-le-createur-du-tube-last-night-dj-robbie-tourne-un-clip-avec-coulisse-dj-0226b466-9c83-11f0-ba76-fc23b95d5062",
    accent: "from-[#D4AF37]/40 via-[#FF2D9C]/15 to-transparent",
    badge: "Musique · Clip",
  },
  {
    media: "20 Minutes TV",
    date: "L'Update",
    title:
      "Adrien Sebert défend avec passion ce métier de l'ombre qui fait briller vos soirées",
    quote:
      "Il nous emmène dans les coulisses de son univers, entre préparation minutieuse et énergie du dancefloor.",
    url: "https://www.facebook.com/adriensebert",
    accent: "from-[#A855F7]/40 via-[#2D6CFF]/15 to-transparent",
    badge: "Reportage TV",
  },
  {
    media: "Actu.fr / L'Orne Hebdo",
    date: "20 août 2018",
    title: "Adrien Sebert : « DJ, c'est un métier »",
    quote:
      "Le DJ représente 80 % de la réussite d'une soirée — alors qu'il ne coûte pas 10 % du budget.",
    url: "https://actu.fr/normandie/_61/adrien-sebert-dj-cst-metier_18237476.html",
    accent: "from-[#FF2D9C]/40 via-[#D4AF37]/15 to-transparent",
    badge: "Portrait",
  },
];

export const Press = () => {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-black border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.10),transparent_60%)]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="eyebrow inline-flex items-center gap-2">
            <Newspaper size={13} /> Vu dans la presse
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Ils parlent de moi. <span className="aurora-text-gradient">Et je n'invente rien.</span>
          </h2>
          <p className="mt-5 text-zinc-400 leading-relaxed">
            Reportages TV, articles de presse régionale et nationale : ma démarche,
            mon parcours et mes collaborations sont reconnus par les médias.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {ARTICLES.map((a, i) => (
            <motion.a
              key={a.title}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`press-${i}`}
              className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-[#D4AF37]/40 bg-[#0A0A0A] transition-all hover:-translate-y-1 flex flex-col"
            >
              <div className={`relative h-2 bg-gradient-to-r ${a.accent}`} />

              <div className="p-7 md:p-8 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-3 mb-5">
                  <div>
                    <div className="text-base md:text-lg font-bold text-white tracking-tight">
                      {a.media}
                    </div>
                    <div className="text-xs uppercase tracking-[0.22em] text-zinc-500 mt-1">
                      {a.date}
                    </div>
                  </div>
                  <span className="px-2.5 py-1 rounded-full text-[10px] tracking-[0.2em] uppercase font-semibold bg-white/5 border border-white/10 text-[#D4AF37] whitespace-nowrap">
                    {a.badge}
                  </span>
                </div>

                <h3 className="text-base md:text-lg font-semibold text-white leading-snug">
                  « {a.title} »
                </h3>

                <div className="relative mt-5 pl-4 border-l border-[#D4AF37]/40 flex-1">
                  <Quote
                    size={14}
                    className="absolute -left-1.5 -top-0.5 text-[#D4AF37] bg-[#0A0A0A] p-0.5 rounded-full"
                  />
                  <p className="text-sm text-zinc-400 italic leading-relaxed">
                    {a.quote}
                  </p>
                </div>

                <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#D4AF37] group-hover:text-[#E9C766] font-medium">
                  Lire l'article <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs text-zinc-500 tracking-[0.18em] uppercase">
          <span className="text-zinc-400">Cités également par</span>
          <span>Noxway</span>
          <span className="text-zinc-700">·</span>
          <span>20 Minutes TV</span>
          <span className="text-zinc-700">·</span>
          <span>Ouest-France</span>
          <span className="text-zinc-700">·</span>
          <span>L'Orne Hebdo</span>
          <span className="text-zinc-700">·</span>
          <span>Actu.fr</span>
        </div>
      </div>
    </section>
  );
};
